/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Total/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Total({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/EditRules/Total"
  
}) {
let rulesetCustomPaymentPlanRulesetMaxLengthTypeValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'custom_payment_plan_ruleset.max_length_type',
})
let constantData = 'total'
let aggregateData = fromAggregate.equals(rulesetCustomPaymentPlanRulesetMaxLengthTypeValueData, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="ruleset.custom_payment_plan_ruleset.max_length_type"
 data="'total'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 onClick={onClick}
 text="Total"
/>
{children}
</React.Fragment>)
}